/* eslint-disable react-hooks/exhaustive-deps */
import LeftArrow from 'icons/black.svg';
import SearchIcon from 'icons/search.svg';
import { useRouter } from 'next/router';
import { ReactNode, useEffect, useState } from 'react';
import { Search } from 'react-vant';
import { SearchProps } from 'react-vant/es/search';

export default function SearchInput({
  placeholder = '请输入商品名称、品牌型号',
  back,
  hideBack,
  slot,
  onSearch,
  initVal,
  watchRouter,
  autofocus,
  isSearchSku,
  ...props
}: SearchProps & {
  back?: Function;
  hideBack?: boolean;
  slot?: ReactNode;
  initVal?: string;
  watchRouter?: boolean;
  onClickSearchIcon?: (v) => void;
  autofocus?: boolean;
  isSearchSku?: boolean;
}) {
  const router = useRouter();
  const [value, setValue] = useState(initVal ?? '');

  const navBack = () => {
    if (typeof back === 'function') {
      back();
    } else {
      history.back();
    }
  };
  const clear = () => {
    onSearchKey('');
  };
  const onSearchKey = (v) => {
    if (isSearchSku && !v) setValue('钢筋');
    onSearch?.(v || '钢筋');
  };

  useEffect(() => {
    if (watchRouter) {
      setValue(router.query.key as string);
    }
  }, [router.query.key]);

  return (
    <>
      <div className="custom-search">
        {!hideBack && (
          <div className="back-box" onClick={navBack}>
            <LeftArrow />
          </div>
        )}
        {slot}
        {props.children}
        <Search
          value={value}
          leftIcon={null}
          rightIcon={
            <span className="icon-box" onClick={() => onSearchKey(value)}>
              <SearchIcon />
            </span>
          }
          autofocus={autofocus}
          onChange={setValue}
          onSearch={onSearchKey}
          onClear={clear}
          placeholder={placeholder}
          {...props}
        />
      </div>
      <style jsx>{`
        .custom-search {
          display: flex;
          flex: 1;
          background-color: #fff;
        }
        .back-box {
          display: flex;
          align-items: center;
          width: 20px;
          justify-content: flex-end;
        }
        .back-box :global(svg) {
          height: 14px;
        }
        .icon-box :global(svg) {
          transform: translateY(2px);
        }
        .custom-search :global(.rv-search__content) {
          align-items: center;
          height: 40px;
          background: #f2f2f2;
          border-radius: 3px;
        }
        .custom-search :global(.rv-search) {
          flex: 1;
        }
      `}</style>
    </>
  );
}

export function SearchInputIndex({
  placeholder = '请输入商品名称、品牌型号',
  back,
  hideBack,
  slot,
  onSearch,
  initVal,
  watchRouter,
  autofocus,
  backgroundColor = '#009ff2',
  searchFieldBgColor = '#fff',
  isSearchSku,
  ...props
}: SearchProps & {
  back?: Function;
  hideBack?: boolean;
  slot?: ReactNode;
  initVal?: string;
  watchRouter?: boolean;
  onClickSearchIcon?: (v) => void;
  autofocus?: boolean;
  backgroundColor?: string;
  searchFieldBgColor?: string;
  isSearchSku?: boolean;
}) {
  const router = useRouter();
  const [value, setValue] = useState(initVal ?? '');

  const navBack = () => {
    if (typeof back === 'function') {
      back();
    } else {
      history.back();
    }
  };
  const clear = () => {
    onSearchKey('');
  };

  const onSearchKey = (v) => {
    if (isSearchSku && !v) setValue('钢筋');
    onSearch?.(v || '钢筋');
  };

  useEffect(() => {
    if (watchRouter) {
      setValue(router.query.key as string);
    }
  }, [router.query.key]);

  return (
    <>
      <div
        className="custom-search"
        style={{
          background: backgroundColor,
        }}
      >
        {!hideBack && (
          <div className="back-box" onClick={navBack}>
            <LeftArrow />
          </div>
        )}
        {slot}
        {props.children}
        <Search
          value={value}
          rightIcon={
            <span className="icon-box" onClick={() => onSearchKey(value)}>
              搜索
            </span>
          }
          leftIcon={
            <span className="left-iconbox">
              <SearchIcon />
            </span>
          }
          autofocus={autofocus}
          onChange={setValue}
          onSearch={onSearchKey}
          onClear={clear}
          placeholder={placeholder}
          {...props}
        />
      </div>
      <style jsx>{`
        .custom-search {
          display: flex;
          flex: 1;
        }
        .back-box {
          display: flex;
          align-items: center;
          width: 20px;
          justify-content: flex-end;
        }

        .left-iconbox {
          display: flex;
          justify-content: center;
          height: 32px;
          align-items: center;
          padding-right: 8px;
          padding-left: 4px;
        }
        .back-box :global(svg) {
          height: 14px;
        }
        .icon-box :global(svg) {
          transform: translateY(2px);
        }

        .icon-box {
          line-height: 26px;
          color: #f5222d;
          font-size: 14px;
        }
        .custom-search :global(.rv-search__content) {
          align-items: center;
          height: 32px;
          border-radius: 18px;
          background: ${searchFieldBgColor};
        }
        .custom-search :global(.rv-search) {
          flex: 1;
          height: 32px;
          padding: 0;
          background: ${backgroundColor};
        }
        .custom-search :global(.rv-field__right-icon) {
          padding-right: 16px;
        }
      `}</style>
    </>
  );
}

export function SearchInputIndexV2({
  placeholder = '请输入商品名称、品牌型号',
  back,
  hideBack,
  slot,
  onSearch,
  initVal,
  watchRouter,
  autofocus,
  isSearchSku,
  ...props
}: SearchProps & {
  back?: Function;
  hideBack?: boolean;
  slot?: ReactNode;
  initVal?: string;
  watchRouter?: boolean;
  onClickSearchIcon?: (v) => void;
  autofocus?: boolean;
  isSearchSku?: boolean;
}) {
  const router = useRouter();
  const [value, setValue] = useState(initVal ?? '');

  const navBack = () => {
    if (typeof back === 'function') {
      back();
    } else {
      history.back();
    }
  };
  const clear = () => {
    onSearchKey('');
  };
  const onSearchKey = (v) => {
    if (isSearchSku && !v) setValue('钢筋');
    onSearch?.(v || '钢筋');
  };

  useEffect(() => {
    if (watchRouter) {
      setValue(router.query.key as string);
    }
  }, [router.query.key]);

  return (
    <>
      <div className="custom-search">
        {!hideBack && (
          <div className="back-box" onClick={navBack}>
            <LeftArrow />
          </div>
        )}
        {slot}
        {props.children}
        <Search
          value={value}
          rightIcon={
            <span className="left-iconbox">
              <SearchIcon />
            </span>
          }
          leftIcon={null}
          autofocus={autofocus}
          onChange={setValue}
          onSearch={onSearchKey}
          onClear={clear}
          placeholder={placeholder}
          {...props}
        />
      </div>
      <style jsx>{`
        .custom-search {
          display: flex;
          flex: 1;
        }
        .back-box {
          display: flex;
          align-items: center;
          width: 20px;
          justify-content: flex-end;
        }

        .left-iconbox {
          display: flex;
          justify-content: center;
          height: 32px;
          align-items: center;
          padding-right: 8px;
          padding-left: 4px;
        }
        .back-box :global(svg) {
          height: 14px;
        }
        .icon-box :global(svg) {
          transform: translateY(2px);
        }

        .icon-box {
          line-height: 26px;
          color: #f5222d;
          font-size: 14px;
        }
        .custom-search :global(.rv-search__content) {
          align-items: center;
          height: 32px;
          background: #f2f2f2;
          border-radius: 3px;
        }
        .custom-search :global(.rv-search) {
          flex: 1;
          height: 32px;
          padding: 0;
        }
        .custom-search :global(.rv-field__right-icon) {
          padding-right: 4px;
        }
      `}</style>
    </>
  );
}
